"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateRulePayload = exports.Rule = exports.CompareOp = exports.RuleScope = exports.TriggerEvent = exports.UserTriggerType = exports.TriggerType = exports.ChannelId = exports.RuleId = exports.MIN_INTERVAL_SECONDS = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const date_1 = require("../date");
const Device = __importStar(require("./device"));
const Tenant = __importStar(require("./tenant"));
const User = __importStar(require("./user"));
exports.NAMESPACE = 'Culligan.Rule';
exports.MIN_INTERVAL_SECONDS = 60;
exports.RuleId = effect_1.Schema.NonEmptyString.annotations({
    identifier: `${exports.NAMESPACE}.RuleId`,
    description: 'Unique rule identifier',
});
exports.ChannelId = effect_1.Schema.NonEmptyString.annotations({
    identifier: `${exports.NAMESPACE}.ChannelId`,
    description: 'Notification channel identifier',
});
exports.TriggerType = effect_1.Schema.Literal('registry', 'connection', 'property', 'alarm', 'error', 'event').annotations({
    identifier: `${exports.NAMESPACE}.TriggerType`,
    description: 'Device event trigger type',
});
exports.UserTriggerType = exports.TriggerType.pipe(effect_1.Schema.pickLiteral('registry', 'connection', 'property', 'alarm', 'event')).annotations({
    identifier: `${exports.NAMESPACE}.UserTriggerType`,
    description: 'Device event trigger type (excludes deprecated error type)',
});
exports.TriggerEvent = effect_1.Schema.Literal('on_new_datapoint', 'on_value_change', 'on_value_compare', 'on_value_change_compare').annotations({
    identifier: `${exports.NAMESPACE}.TriggerEvent`,
    description: 'Trigger event kind',
});
exports.RuleScope = effect_1.Schema.Literal('device', 'model', 'tenant', 'all').annotations({
    identifier: `${exports.NAMESPACE}.RuleScope`,
    description: 'Scope the rule targets',
});
exports.CompareOp = effect_1.Schema.Literal('==', '!=', '<', '>', '<=', '>=').annotations({
    identifier: `${exports.NAMESPACE}.CompareOp`,
    description: 'Value comparison operator',
});
exports.Rule = effect_1.Schema.Struct({
    id: exports.RuleId,
    createdAt: effect_1.Schema.optionalWith(date_1.DateFromUtcIsoDateString, { exact: true }),
    updatedAt: effect_1.Schema.optionalWith(date_1.DateFromUtcIsoDateString, { exact: true }),
    userId: User.Id,
    name: effect_1.Schema.NullOr(effect_1.Schema.NonEmptyString),
    channelIds: effect_1.Schema.Array(exports.ChannelId),
    scope: exports.RuleScope,
    deviceSerialNumbers: effect_1.Schema.propertySignature(effect_1.Schema.Array(Device.Class.Common.Id)).annotations({
        description: 'Target device serial numbers (scope=device)',
    }),
    models: effect_1.Schema.propertySignature(effect_1.Schema.Array(Device.Class.Common.ModelCode)).annotations({
        description: 'Target device models (scope=model)',
    }),
    tenantId: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(Tenant.Id)).annotations({
        description: 'Target tenant ID (scope=tenant)',
    }),
    active: effect_1.Schema.Boolean,
    triggerType: exports.TriggerType,
    triggerEvent: exports.TriggerEvent,
    propertyName: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.NonEmptyString), { exact: true }),
    valueComparisonOperator: effect_1.Schema.NullOr(exports.CompareOp),
    valueThreshold: effect_1.Schema.NullOr(effect_1.Schema.NonEmptyString),
    occurrenceName: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(effect_1.Schema.NonEmptyString)).annotations({
        description: 'Occurrence name (triggerType=alarm/event)',
    }),
    emailSubject: effect_1.Schema.NullOr(effect_1.Schema.String),
    emailBody: effect_1.Schema.NullOr(effect_1.Schema.String),
    minInterval: effect_1.Schema.propertySignature(effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative())).annotations({
        description: 'Minimum seconds between deliveries',
    }),
    gracePeriod: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative()))).annotations({
        description: 'Grace period in seconds before triggering',
    }),
    lastSentAt: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(date_1.DateFromUtcIsoDateString), { exact: true }),
    // V1 parity markers — written on create so rules look identical to V1-created documents.
    // The remaining V1 channel fields (pushTitle, smsMessage, webhookMetadata, etc.) are
    // intentionally omitted: this email-only API never writes or surfaces them, and the V1
    // delivery path reads them off the raw document via the V1 type, not this schema.
    version: effect_1.Schema.optionalWith(effect_1.Schema.Literal(1), { exact: true }),
    actionType: effect_1.Schema.optionalWith(effect_1.Schema.Literal('notification'), { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.Rule`,
    description: 'An automation rule that triggers notification actions based on device events',
});
// Each scope owns exactly one target field, and the other two must be empty.
// The rules engine ORs the target dimensions, and device deregistration deletes
// a rule once its serial list empties, so a mixed rule would lose its model or
// tenant targeting along with its last device. Empty and null off-scope targets
// stay legal: that is the shape a stored rule reads back as, and clients
// round-trip it on update.
//
// Keyed by scope rather than listed, so a new RuleScope member cannot be added
// without either declaring the target field it owns or being excluded here on
// purpose. 'all' is excluded because it owns no target field.
const TARGET_RULES = {
    device: {
        field: 'deviceSerialNumbers',
        isSet: payload => (payload.deviceSerialNumbers?.length ?? 0) > 0,
        missingMessage: 'deviceSerialNumbers must not be empty when scope is device',
    },
    model: {
        field: 'models',
        isSet: payload => (payload.models?.length ?? 0) > 0,
        missingMessage: 'models must not be empty when scope is model',
    },
    tenant: {
        field: 'tenantId',
        isSet: payload => payload.tenantId != null,
        missingMessage: 'tenantId is required when scope is tenant',
    },
};
/**
 * Returns the first target validation failure, or null when the targets are
 * consistent with the scope. The two passes are ordered deliberately: a caller
 * who omitted the target their scope requires is told that, rather than being
 * sent after an unrelated field they also happened to populate.
 *
 * @param payload - The scope and target fields to check.
 * @returns The failure message, or null.
 */
const validateTargets = (payload) => {
    for (const [scope, rule] of Object.entries(TARGET_RULES)) {
        if (payload.scope === scope && !rule.isSet(payload)) {
            return rule.missingMessage;
        }
    }
    for (const [scope, rule] of Object.entries(TARGET_RULES)) {
        if (payload.scope !== scope && rule.isSet(payload)) {
            return `${rule.field} must be empty when scope is ${payload.scope}`;
        }
    }
    return null;
};
exports.CreateRulePayload = effect_1.Schema.Struct({
    name: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.NonEmptyString), { exact: true }),
    channelIds: effect_1.Schema.Array(exports.ChannelId).pipe(effect_1.Schema.minItems(1)),
    scope: exports.RuleScope,
    // Provisional ceiling — revisit with product if fleet rules need to target >100 devices.
    deviceSerialNumbers: effect_1.Schema.optionalWith(effect_1.Schema.Array(Device.Class.Common.Id).pipe(effect_1.Schema.maxItems(100)), {
        exact: true,
    }),
    models: effect_1.Schema.optionalWith(effect_1.Schema.Array(Device.Class.Common.ModelCode), { exact: true }),
    tenantId: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Tenant.Id), { exact: true }),
    active: effect_1.Schema.Boolean,
    triggerType: exports.UserTriggerType,
    triggerEvent: exports.TriggerEvent,
    propertyName: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.NonEmptyString), { exact: true }),
    valueComparisonOperator: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(exports.CompareOp), { exact: true }),
    valueThreshold: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.NonEmptyString), { exact: true }),
    occurrenceName: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.NonEmptyString), { exact: true }),
    emailSubject: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String), { exact: true }),
    emailBody: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String), { exact: true }),
    minInterval: effect_1.Schema.optionalWith(effect_1.Schema.Int.pipe(effect_1.Schema.greaterThanOrEqualTo(exports.MIN_INTERVAL_SECONDS)), {
        exact: true,
    }),
    gracePeriod: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative())), { exact: true }),
})
    .pipe(effect_1.Schema.filter(payload => {
    const isAlarmOrEvent = payload.triggerType === 'alarm' || payload.triggerType === 'event';
    if (payload.triggerEvent === 'on_value_compare' && payload.valueComparisonOperator == null) {
        return 'valueComparisonOperator is required when triggerEvent is on_value_compare';
    }
    if (payload.triggerEvent === 'on_value_compare' && payload.valueThreshold == null) {
        return 'valueThreshold is required when triggerEvent is on_value_compare';
    }
    if (isAlarmOrEvent && payload.triggerEvent !== 'on_new_datapoint') {
        return 'triggerEvent must be on_new_datapoint when triggerType is alarm or event';
    }
    if (isAlarmOrEvent && payload.occurrenceName == null) {
        return 'occurrenceName is required when triggerType is alarm or event';
    }
    if (payload.triggerType === 'property' && payload.propertyName == null) {
        return 'propertyName is required when triggerType is property';
    }
    return validateTargets(payload) ?? true;
}))
    .annotations({
    identifier: `${exports.NAMESPACE}.CreateRulePayload`,
    description: 'Payload for creating or updating a rule',
});
//# sourceMappingURL=rule.js.map